import clsx from "clsx";
import React, { PropsWithChildren } from "react";

import { Button, ButtonProps } from "../../buttons/button";

export interface SubmitButtonProps extends Pick<ButtonProps, "disabled"> {}

export function SubmitButton({
  disabled,
  children,
  ...rest
}: PropsWithChildren<SubmitButtonProps>) {
  return (
    <Button
      variant={disabled ? "neutral" : "primary"}
      type="submit"
      className={clsx("w-fit", disabled && "!opacity-50")}
      size="sm"
      disabled={disabled}
      {...rest}
    >
      {children}
    </Button>
  );
}
